import Form from './form.vue';
import TableConfig from './table_config.vue';

export { Form, TableConfig };
